/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=4944c2c8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4944c2c8&lang=less&scoped=true"

import exportComponent from "/Users/fiture/Fiture/officialwebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4944c2c8"]])

export default __exports__